// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Breadcrumb_breadCrumb__kRdGJ {
    font-size: 10px;
    text-transform: uppercase;
    margin-bottom: 8px;
    height: 22px;
    letter-spacing: 2px;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 100;
    margin: 0 0 22px;
    line-height: 1.4;
    text-rendering: optimizelegibility;
}







`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Breadcrumb/Breadcrumb.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,uHAAuH;IACvH,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;AACtC","sourcesContent":[".breadCrumb {\n    font-size: 10px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n    height: 22px;\n    letter-spacing: 2px;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-weight: 100;\n    margin: 0 0 22px;\n    line-height: 1.4;\n    text-rendering: optimizelegibility;\n}\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadCrumb": `Breadcrumb_breadCrumb__kRdGJ`
};
export default ___CSS_LOADER_EXPORT___;
